<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da odbijete zahtev korisnika
        {{ member.user_full_name }}?
      </p>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="rejectMember"
        :disabled="loading"
      >
        <span v-if="!loading">Pošalji</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState('modal', ['member']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getPendingMembersByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),

    rejectMember() {
      if (this.loading) {
        return;
      }

      this.loadingStarted();
      let rejectRequest = {
        community_id: this.member.community_id,
        member_id: this.member.id
      };
      axios
        .post('/member/reject', rejectRequest)
        .then(() => {
          this.getPendingMembersByCommunity(this.$route.params.id);
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped></style>
